import React, { createContext, useContext, useState } from 'react';
import { ANY_GENRE } from '../utils/libraryFilters';

const WishlistFilterContext = createContext();

// eslint-disable-next-line react-refresh/only-export-components
export const useWishlistFilters = () => {
  const context = useContext(WishlistFilterContext);
  if (!context) {
    throw new Error('useWishlistFilters must be used within a WishlistFilterProvider');
  }
  return context;
};

export const WishlistFilterProvider = ({ children }) => {
  const [activeContentType, setActiveContentType] = useState('all');
  const [activeStatus, setActiveStatus] = useState('all');
  const [genre, setGenre] = useState(ANY_GENRE);
  const [yearFrom, setYearFrom] = useState('');
  const [yearTo, setYearTo] = useState('');

  const resetFilters = () => {
    setActiveContentType('all');
    setActiveStatus('all');
    setGenre(ANY_GENRE);
    setYearFrom('');
    setYearTo('');
  };

  return (
    <WishlistFilterContext.Provider value={{
      activeContentType,
      setActiveContentType,
      activeStatus,
      setActiveStatus,
      genre,
      setGenre,
      yearFrom,
      setYearFrom,
      yearTo,
      setYearTo,
      resetFilters
    }}>
      {children}
    </WishlistFilterContext.Provider>
  );
};

export default WishlistFilterContext;
